import { useNavigate } from "react-router-dom";
import { useClientRecordCoachingReview } from "@/lib/clientRecordQueries";

export default function CoachingReviewTab({ workspaceId, memberId }) {
  const navigate = useNavigate();
  const { data, isPending, isError } = useClientRecordCoachingReview(workspaceId, memberId);

  return (
    <div data-testid="client-360-coaching-review-tab" className="space-y-6">
      <div className="flex justify-end">
        <button
          onClick={() => navigate(`/rehearsal-room/w/${workspaceId}/feedback`)}
          className="text-xs text-terracotta hover:underline"
          data-testid="client-360-coaching-review-open-full-page"
        >
          Open full Feedback workbench →
        </button>
      </div>
      {isPending ? (
        <p className="text-sm text-ink-soft" data-testid="client-360-coaching-review-loading">Loading…</p>
      ) : isError ? (
        <p className="text-sm text-red-600" data-testid="client-360-coaching-review-error">Couldn't load coaching review.</p>
      ) : (
        <>
          <div>
            <h2 className="font-serif text-lg text-ink mb-2">Feedback</h2>
            {data.feedback.length === 0 ? (
              <p className="text-sm text-ink-soft" data-testid="client-360-feedback-empty">No published feedback yet.</p>
            ) : (
              <div className="space-y-2" data-testid="client-360-feedback-list">
                {data.feedback.map((f) => (
                  <div key={f.fbk_id} className="border border-ink/10 rounded-lg p-3 bg-white/50" data-testid={`client-360-feedback-${f.fbk_id}`}>
                    <p className="text-sm text-ink font-medium">{f.focus}</p>
                    <p className="text-xs text-ink-soft">v{f.version_number} · {f.status}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div>
            <h2 className="font-serif text-lg text-ink mb-2">Session recaps</h2>
            {data.recaps.length === 0 ? (
              <p className="text-sm text-ink-soft" data-testid="client-360-recaps-empty">No recaps yet.</p>
            ) : (
              <div className="space-y-2" data-testid="client-360-recaps-list">
                {data.recaps.map((r) => (
                  <div key={r.srec_id} className="border border-ink/10 rounded-lg p-3 bg-white/50" data-testid={`client-360-recap-${r.srec_id}`}>
                    <p className="text-xs text-ink-soft mb-1">{r.session_title}</p>
                    <p className="text-sm text-ink">{r.summary_text}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
